import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

interface Props {
  id?: string
  avatarUrl?: string
  name: string
  role?: string
  render?: () => React.ReactElement | string
  sm?: boolean
}

const Person: React.FC<Props> = ({
  id,
  avatarUrl = '',
  name,
  role = '',
  render,
  sm = false
}) => {
  return (
    <div className={classNames('person', { _sm: sm })}>
      {avatarUrl ? (
        <div className="person__avatar">
          <img src={avatarUrl} alt={name} />
        </div>
      ) : null}
      <div className="person__content">
        <Link to={`/participant/${id}`} className="person__name text-body-small-bold">
          {name}
        </Link>
        {render ? (
          <div className="person__role">{render()}</div>
        ) : role ? (
          <p className="person__role text-caption text-secondary-color">
            {role}
          </p>
        ) : null}
      </div>
    </div>
  )
}

export default Person
